import { ActionType, RootAction } from '@/actions/actiontypes';
import { PreferencesState } from '@/state';

const initialState: PreferencesState = new PreferencesState();

export const preferencesReducer = (
    state: PreferencesState = initialState,
    action: RootAction
) => {
    switch (action.type) {
        case ActionType.BOOTSTRAP:
            return action.bootstrappedState.preferences;
        case ActionType.PREFERENCES_UPDATE:
            return state.override(action);
        case ActionType.PREFERENCES_RESET:
            return new PreferencesState();
        case ActionType.MAP_LAYER_SET:
            return state.override({ mapLayer: action.maplayer });
        default:
            return state;
    }
};
